import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "help" }, " The following columns will be mapped with default values. They can be edited once the table is created. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cc_hydra_operation_form = _resolveComponent("cc-hydra-operation-form")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_side_pane = _resolveComponent("side-pane")!

  return (_openBlock(), _createBlock(_component_side_pane, {
    title: _ctx.title,
    onClose: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      (_ctx.operation)
        ? (_openBlock(), _createBlock(_component_cc_hydra_operation_form, {
            key: _ctx.formRenderKey,
            ".operation": _ctx.operation,
            ".resource": _ctx.resource,
            ".shape": _ctx.shape,
            ".error": _ctx.error,
            ".submitting": _ctx.isSubmitting,
            onSubmit: _ctx.onSubmit,
            onCancel: _ctx.onCancel
          }, null, 8, [".operation", ".resource", ".shape", ".error", ".submitting", "onSubmit", "onCancel"]))
        : _createCommentVNode("", true),
      (_ctx.preselectedColumns.length > 0)
        ? (_openBlock(), _createBlock(_component_o_field, {
            key: 1,
            label: "Mapped columns",
            class: "content",
            addons: false
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preselectedColumns, (column) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: column.id.value
                  }, _toDisplayString(column.name), 1))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "onClose"]))
}